const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelectorAll(".js-color-swatches-link")
						.forEach((item) =>
							item.setAttribute("href", event.currentTarget.dataset.variantLink)
						);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src)
											.pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src)
											.pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}


(function () {
	colorSwatches();


	document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-action="add"]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    console.log('Cart btn clicked, variantId:', variantId);
    if (!variantId) return;

    const icon = btn.querySelector('svg:not(.spinner)');
    const spinner = btn.querySelector('.card__cart-btn-spinner');

    btn.disabled = true;
    icon?.classList.add('hidden');
    spinner?.classList.remove('hidden');

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
    })
        .then((res) => {
            if (!res.ok) return res.json().then(err => { throw new Error(err.description || 'Add to cart failed') });
            return res.json();
        })
        .then(() => {
            // Fetch cart + cart-drawer section HTML zároveň
            return fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                    // 1. Aktualizuj počítadlo
                    const countBubbles = document.querySelectorAll('.cart-count-bubble');
                    countBubbles.forEach((el) => {
                        const count = el.querySelector('[aria-hidden]');
                        const accessible = el.querySelector('.visually-hidden');
                        if (count) count.textContent = cart.item_count;
                        if (accessible) accessible.textContent = cart.item_count;
                        el.classList.remove('hidden');
                    });

                    // 2. Refresh cart drawer HTML přes Shopify Sections API
                    return fetch('/?sections=cart-drawer')
                        .then(r => r.json())
                        .then(sections => {
                            // Nahraď obsah cart draweru
                            const drawerEl = document.querySelector('cart-drawer');
                            if (drawerEl && sections['cart-drawer']) {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
                                const newDrawer = doc.querySelector('cart-drawer');
                                if (newDrawer) {
                                    drawerEl.innerHTML = newDrawer.innerHTML;
                                }
                            }

                            // 3. Dispatch event pro případ že theme má vlastní listener
                            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

                            // 4. Otevři drawer
                            const cartDrawer = document.querySelector('cart-drawer');
                            if (cartDrawer) {
                                cartDrawer.open?.();
                            } else {
                                // Fallback — klikni na cart ikonu
                                document.querySelector('[href="/cart"]')?.click();
                            }
                        });
                });
        })
        .then(() => {
            btn.classList.add('card__cart-btn--added');
            setTimeout(() => btn.classList.remove('card__cart-btn--added'), 1500);
        })
        .catch((err) => {
            console.error('Cart error:', err.message);
        })
        .finally(() => {
            btn.disabled = false;
            icon?.classList.remove('hidden');
            spinner?.classList.add('hidden');
        });
});

})();
